module.exports = __webpack_public_path__ + "img/C47004_F9D00C_EDAF04_E09704-256px.f3816955.png";